import React from 'react';
import { connect } from "react-redux";
import SignatureCanvas from "react-signature-canvas";
import QRCode from "react-qr-code";
import { Button, Col, Row, Checkbox, Tooltip, Spin, Collapse } from "antd";
import signature from '../../const/signature';
import { SIGNATUREQR_ROUTE } from '../Root/routes';
import { getQueryParams, showFull } from '../Helpers/utils';
import { useSignaturePAD } from '../../apis/generalValues'
import SignatureHandleOptions from './SignatureHandleOptions';
import smartphone from '../../resources/img/smartphone.png';
import stepOverPad from '../../resources/img/stepoverpad.png';
import { EditOutlined, CheckOutlined, QrcodeOutlined, FormOutlined, ClearOutlined, SaveOutlined } from '@ant-design/icons';
import updateHWImage from '../../actions/signature/updateHWImage';
import setHWImage from '../../actions/signature/setHWImage';
import getHWImage from '../../actions/signature/getHWImage';
import { maxWidth } from "../Helpers/utils";
import collapseUpIcon from '../../resources/img/NewIcons/sign/collapseUpIcon.svg';
import collapseDownIcon from '../../resources/img/NewIcons/sign/collapseDownIcon.svg';
import { ReactComponent as ImageOrTextIcon } from '../../resources/img/NewIcons/previewer/image_text.svg';
import { ReactComponent as DevicesIcon } from '../../resources/img/NewIcons/previewer/devices.svg';
import { ReactComponent as TabletIcon } from '../../resources/img/NewIcons/previewer/tablet.svg';
import { Typography } from 'antd';
import showMessage from '../../actions/info/showMessage';



const isPageMobile = window.location.href.includes(SIGNATUREQR_ROUTE);
const widthPad = 600;
const heightPad = 148;

class SignatureHandwritten extends React.Component {
    //handSigTypes 1 --> draw, 2 -->QR, 3 -->Signature PAD
    state = { heightPad: 0, widthPad: 0, urlQR: '', padOverwrite: false, handSigType: 1, activeCollapse: ['1'] }
    collapseRef = React.createRef();

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        setTimeout(() => {
            if (this.props.padData && this.sigPad)
                this.sigPad.fromData(this.props.padData);
        }, 50);
        this.initTimerStates();
        window.addEventListener('resize', this.updateCollapseWidth);
        this.updateCollapseWidth();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const currentInfoImageQR = this.props.signatureFiles.infoImageQR;
        if (currentInfoImageQR.base64 && prevProps.signatureFiles.infoImageQR.base64 !== currentInfoImageQR.base64 &&
            currentInfoImageQR && currentInfoImageQR.state === 'drawing' && this.props.useImage === '2') {
            this.props.modalDismiss();
        }
        if (currentInfoImageQR && prevProps.signatureFiles.infoImageQR.state !== currentInfoImageQR.state) {
            if (currentInfoImageQR.state === 'cancelled') {
                this.clearIntervals();
                if (this.props.onSubmit)
                    this.props.onSubmit()
                if (!isPageMobile)
                    this.initTimerStates()
            }
            if (currentInfoImageQR.state === 'finished') {
                this.clearIntervals();
                this.props.modalDismiss();
            }
            this.handleResize()
        }
        if (prevProps.useImage !== this.props.useImage) {
            if (this.props.useImage === '2')
                this.initTimerStates();
            else {
                this.clearIntervals();
                this.props.updateHWImage(JSON.stringify({ state: "cancelled" }))
            }
        }
        if (prevProps.hwimgid !== this.props.hwimgid && this.props.hwimgid)
            this.initTimerStates();

        if (!prevProps.signatureFiles.loadingPad && this.props.signatureFiles.loadingPad) {
            this.initTimerStates();
        }
        //this.updateCollapseWidth();
    }

    componentWillUnmount() {
        this.setState({ urlQR: '' });
        this.clearIntervals();
        window.removeEventListener('resize', this.handleResize)
        window.removeEventListener('resize', this.updateCollapseWidth);

    }

    initTimerStates = async () => {
        if (isPageMobile)
            this.timerSendImage = setInterval(() => this.sendImage(), 1000);
        else {
            if (this.props.signatureFiles.hwimgid && this.props.signatureFiles.infoImageQR.state !== 'drawingPad') {
                await this.props.getHWImage({ "id": this.props.signatureFiles.hwimgid }, this.props.signatureFiles.infoImageQR.state);
                const urlQR = window.location.origin + window.location.pathname + '#' + SIGNATUREQR_ROUTE + '?hwimgid=' + this.props.hwimgid;
                console.log(urlQR)
                this.setState({ urlQR: urlQR, padOverwrite: this.props.padOverwrite },
                    () => {
                        if (this.props.signatureFiles.infoImageQR.state !== 'drawing' && this.props.signatureFiles.infoImageQR.state !== 'drawingPad')
                            this.props.setTimerGetImageQR();
                    }
                )
            }
        }
        this.handleResize();
    }

    handleResize = () => {
        setTimeout(function () {
            const widthApp = window.innerWidth
            const heightApp = window.innerHeight
            const isVerticalTabs = widthApp >= maxWidth || (widthApp > heightApp);
            const fixHeight = isPageMobile ? 60 : 40;
            const fixHeader = this.headerCanvas ? this.headerCanvas.clientHeight : 0;
            const fixFooter = this.footerCanvas ? this.footerCanvas.clientHeight : (showFull() || isPageMobile ? 30 : 0);
            const fixBtnOptions = this.btnOptionsHandWritten ? this.btnOptionsHandWritten.clientHeight + (isVerticalTabs ? 43 : 100) : 0;
            const heightPad = (this.columnQRPad ? this.columnQRPad.clientHeight : (heightApp - (isPageMobile ? 0 : fixBtnOptions))) - fixHeight - fixHeader - fixFooter;
            const widthPad = (this.colCanvas ? this.colCanvas.clientWidth : widthApp) - (showFull() ? 25 : 8) - (isPageMobile ? 20 : 0) - (isVerticalTabs ? 6 : 0);
            this.setState({ heightPad, widthPad });
        }.bind(this), 100)
    };

    onStartPadSigning = () => {
        if (this.props.onStartPadSigning)
            this.props.onStartPadSigning();
        if (this.props.modalDismiss)
            this.props.modalDismiss();
    }

    clearIntervals = () => {
        clearInterval(this.timerSendImage);
        this.timerSendImage = null
        if (!this.props.signatureFiles.infoImageQR.base64 && this.props.clearTimerGetImageQR)
            this.props.clearTimerGetImageQR();
    }

    trimImage = async (state) => {
        if (isPageMobile)
            await this.sendImage(state)
        this.clearIntervals();
        this.props.modalDismiss();
        const sigPad = this.sigPad;
        let data = "";
        if (sigPad)
            data = sigPad.toData();
        this.props.onSubmit(this.getCanvasImage(), data);
    };

    clear = () => {
        this.sigPad.clear();
    }

    getCanvasImage = () => {
        if (!this.sigPad)
            return "";
        return this.sigPad.getCanvas().toDataURL('image/png').replace("data:image/png;base64,", "");
    }

    sendImage = async (state = "drawing") => {
        const base64 = this.getCanvasImage();
        const info = { state, base64 };
        const data = {
            id: this.props.params.hwimgid,
            info: JSON.stringify(info)
        }
        await this.props.setHWImage(data);
    }

    changeSaveImage = () => {
        this.props.handlePadOverwriteChange();
        this.setState({ padOverwrite: !this.state.padOverwrite })
    }

    getStyleOptionButtons = (pressed, disabled = null) => {
        if (pressed)
            return 'button-pressed'
        else if (disabled)
            return 'button-disabled'
        else
            return 'button-enabled'
    }

    copyText = () => {
        navigator.clipboard.writeText(this.state.urlQR)
            .then(() => {
                this.props.showMessage('success', signature[this.props.language].copyQR);
            })
            .catch(err => {
                this.props.showMessage('error', signature[this.props.language].errCopyQR);
                console.error(signature[this.props.language].errCopyQR+': ', err);
            });
    };

    updateCollapseWidth = () => {
        if (this.collapseRef.current) {
            const width = this.collapseRef.current.offsetWidth;
            return width;
        }
    };

    renderQR = () => {
        return <div>
            <QRCode className="mt-10 mb-10" size={125} value={this.state.urlQR} />
            <Button type='ghost' onClick={this.copyText}>
                {signature[this.props.language].copyShareQR}
            </Button>
        </div>
    }

    renderOptionsHandwritten = () => {
        const isHandWritten = this.state.handSigType === 1;
        if (!isPageMobile && !showFull())
            return (<div ref={(ref) => this.btnOptionsHandWritten = ref} style={{ textAlign: 'center' }} >
                <Tooltip title={signature[this.props.language].signatureTitleTypeID[2]}>
                    <Button className={this.getStyleOptionButtons(isHandWritten)} style={{ marginRight: '10px' }} icon={<EditOutlined />} type={'primary sign-btn'} htmlType={'button'}
                        onClick={() => this.setState({ handSigType: 1 })} />
                </Tooltip>
                <Tooltip title={signature[this.props.language].handwrittenSignatureOptions[0]}>
                    <Button className={this.getStyleOptionButtons(this.state.handSigType === 2)} style={{ marginRight: '10px' }} icon={<QrcodeOutlined />}
                        type={'primary sign-btn'} htmlType={'button'} onClick={() => this.setState({ handSigType: 2 })} />
                </Tooltip>
                {useSignaturePAD ? this.renderBtnPad(() => this.setState({ handSigType: 3 }, () => this.onStartPadSigning())) : null}
                <div className={'divider-buttons'} style={{ height: '2.9em', marginRight: '10px' }} />
                <Tooltip title={this.state.padOverwrite ? signature[this.props.language].saveHandwrittenSignatureDisable : signature[this.props.language].saveHandwrittenSignatureEnable}>
                    <Button className={this.getStyleOptionButtons(this.state.padOverwrite)} style={{ marginRight: '10px' }} icon={<SaveOutlined />} type={'primary sign-btn'}
                        htmlType={'button'} onClick={() => this.changeSaveImage()} />
                </Tooltip>
                {isHandWritten ? <Tooltip title={signature[this.props.language].clear}>
                    <Button className={this.getStyleOptionButtons(false)} style={{ marginRight: '10px' }} icon={<ClearOutlined />} type={'primary sign-btn'}
                        htmlType={'button'} onClick={this.clear} />
                </Tooltip> : null}
                {isHandWritten ? <Tooltip title={signature[this.props.language].accept}>
                    <Button className={this.getStyleOptionButtons(false)} style={{ marginRight: '10px' }} icon={<CheckOutlined />} type={'primary sign-btn'}
                        htmlType={'button'} onClick={() => this.trimImage('finished')} />
                </Tooltip> : null}
            </div>)
    }

    renderBtnPad = (action) => {
        const disabledPad = typeof this.props.signatureFiles.loadingPad === 'undefined';
        return <Tooltip title={disabledPad ? signature[this.props.language].disabledPad : signature[this.props.language].enabledPad}>
            {this.props.signatureFiles && this.props.signatureFiles.loadingPad ? <Spin style={{ marginRight: 10 }} /> :
                <Button className={this.getStyleOptionButtons(false, disabledPad)} style={{ marginRight: '10px' }} icon={<FormOutlined />} disabled={disabledPad}
                    type={'primary sign-btn'} htmlType={'button'} onClick={action} />}
            <></>
        </Tooltip>
    }

    renderOptionQR = () => {
        return <div className='handwritten-qr' style={{ display:'flex', gap:30, marginRight: 10, padding: 10, textAlign: 'center', marginBottom: showFull() ? 0 : 10 }}>
            {this.renderQR()}
            <p style={{ textAlign: 'justify', fontSize: '11px' }}>
                {signature[this.props.language].signatureTextTypeID[2].instructions[0]}<br />
                {signature[this.props.language].signatureTextTypeID[2].instructions[1]}<br />
                {signature[this.props.language].signatureTextTypeID[2].instructions[2]}<br />
            </p>
        </div>;
    }

    renderOptionPad = () => {
        return <Row style={{ marginRight: 10, marginTop: 10, padding: 10, }}>
            <Col xs={24} md={18}>
                <Typography style={{ textAlign: 'left' }}>{signature[this.props.language].handwrittenSignatureOptions[1]}</Typography>
            </Col>
            <Col xs={24} md={6} style={{ textAlign: 'right' }}>
                {this.renderBtnPad(this.onStartPadSigning)}
            </Col>
        </Row>;
    }

    getWidthCanvas = () => {
        const widthCollapse = this.updateCollapseWidth();
        if(isPageMobile)
            return this.props.dimApp.width - 50;
        // Never let the canvas be wider than the panel that holds it.
        if(!showFull())
            return widthCollapse - 50;
        else
            return widthCollapse ? Math.min(widthPad, widthCollapse - 50) : widthPad;
    }

    renderCanvas = () => {
        const showFullValue = showFull();
        const showFullOrMobile = showFullValue || isPageMobile
        const widthCanvas = this.getWidthCanvas();

        // The canvas owns the whole panel: the QR and pad options live in their own accordion items.
        return <Col ref={(ref) => this.colCanvas = ref} xs={24} style={showFullOrMobile ? { padding: 10, border: null } : { padding: 0, border: 'none' }}>
            {this.state.heightPad > 0 && this.state.widthPad > 0 ?
                <>
                    <SignatureCanvas throttle={30} minDistance={0} dotSize={1} maxWidth={1} minWidth={1}
                                        ref={(ref) => this.sigPad = ref} canvasProps={{ height: heightPad, width: widthCanvas, className: 'canvasBorder mb-10 mt-10' }} />
                    <Row ref={(ref) => this.footerCanvas = ref} className='handwritten-actions' style={{ justifyContent: 'space-between', maxWidth: widthCanvas > 0 ? widthCanvas : undefined }} >
                        <Button htmlType={'button'} style={{ marginBottom: 0 }}
                            type={'primary light-primary rounded-sm float-right'}
                            onClick={() => this.trimImage('cancelled')}>{signature[this.props.language].cancel}</Button>
                        <Button htmlType={'button'} style={{ marginBottom: 0 }}
                            type={'primary light-primary rounded-sm float-right'}
                            onClick={this.clear}>{signature[this.props.language].clear}</Button>
                        <Button htmlType={'button'} style={{ marginBottom: 0 }}
                            type={'primary light-primary rounded-sm float-right'}
                            onClick={() => this.trimImage('finished')}>
                            {isPageMobile ? signature[this.props.language].title : signature[this.props.language].accept}</Button>
                    </Row>
                </> : <></>}
        </Col>;
}

    renderCheckSaveSignature = () => {
        return <div style={{ marginTop: 10, padding: 10, }}>
            <Checkbox defaultChecked checked={this.state.padOverwrite}
                onChange={this.changeSaveImage}>{signature[this.props.language].saveHandwrittenSignature}</Checkbox>
        </div>;
    }

    renderPanelHeader = (Message, Icon, Active) => {
        return <div style={{ display: 'flex', alignItems: 'center' }}>
            {Icon}
            <Typography className={Active ? 'text-title size18' : 'size18'}>
                {Message}
            </Typography>
        </div>
    };

    getAccordionChildren = () => {
        return [
            {
                key: '1',
                label: this.renderPanelHeader(signature[this.props.language].signatureTitleTypeID[2][0], <ImageOrTextIcon className={this.state.activeCollapse[0] === '1' ? 'icon-menu' : ''} style={{ marginRight: 11 }} />, this.state.activeCollapse[0] === '1'),
                children: <div>{this.renderCanvas()}</div>
            },
            {
                key: '2',
                label: this.renderPanelHeader(signature[this.props.language].signatureTitleTypeID[2][1], <DevicesIcon className={this.state.activeCollapse[0] === '2' ? 'icon-menu' : ''} style={{ marginRight: 11 }} />, this.state.activeCollapse[0] === '2'),
                children: <div>{this.renderOptionQR()}</div>
            },
            {
                key: '3',
                label: this.renderPanelHeader(signature[this.props.language].signatureTitleTypeID[2][2], <TabletIcon className={this.state.activeCollapse[0] === '3' ? 'icon-menu' : ''} style={{ marginRight: 11 }} />, this.state.activeCollapse[0] === '3'),
                children: <div>{this.renderOptionPad()}</div>
            }];
    };

    render() {
        const drawState = this.props.signatureFiles.infoImageQR.state;
        if (drawState === 'drawing' || drawState === 'drawingPad') {
            const tittle = drawState === 'drawing' ? signature[this.props.language].handwrittenSignatureMobile : signature[this.props.language].handwrittenSignaturePad;
            const text = drawState === 'drawing' ? signature[this.props.language].messageUseSignatureMobile : signature[this.props.language].messageUseSignaturePad
            const image = drawState === 'drawing' ? smartphone : stepOverPad;
            return <SignatureHandleOptions title={tittle} text={text} image={image} textButton={signature[this.props.language].accept}
                modalDismiss={this.props.modalDismiss} />;
        }
        else {
            return <><Collapse ref={this.collapseRef} accordion onChange={(activeCollapse) => this.setState({ activeCollapse })} className='mt-40 mb-10 collapse-signature'
                activeKey={this.state.activeCollapse} style={{ background: 'transparent !important' }}
                expandIcon={({ isActive }) => isActive ? <img alt={''} src={collapseUpIcon} /> : <img alt={''} src={collapseDownIcon} />}
                expandIconPosition={'end'} defaultActiveKey={['1']} items={this.getAccordionChildren()} >
            </Collapse>

                {this.renderCheckSaveSignature()}
            </>
        }
    }
}

const mapStateToProps = state => {
    return {
        signatureFiles: state.signatureFiles,
        language: state.auth.language,
        params: getQueryParams(state.router.location.search),
        useImage: state.user.useImage,
        dimApp: state.locate.dimensionsApp,
    };
};

export default connect(mapStateToProps, { getHWImage, setHWImage, updateHWImage, showMessage })(SignatureHandwritten);